import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function InsidePreview() {
  const images = ['https://cdn.magicpatterns.com/uploads/8DH3b1tgV6Y9QSekmhrG2r/Ebook_Florecer_008.png', 'https://cdn.magicpatterns.com/uploads/6pqQkUeuaL1bjooc8VvGpg/Ebook_Florecer_010.png', 'https://cdn.magicpatterns.com/uploads/srAw4w3EuGx4dxfNkMHqqF/Ebook_Florecer_013.png', 'https://cdn.magicpatterns.com/uploads/mifztMYvCzGLag1WSxgVHY/Ebook_Florecer_014.png', 'https://cdn.magicpatterns.com/uploads/27hFjvyicc9VzE1M3R81qK/Ebook_Florecer_016.png', 'https://cdn.magicpatterns.com/uploads/wuaVsd4YtwRQRmvMrMir2G/Ebook_Florecer_017.png', 'https://cdn.magicpatterns.com/uploads/o8GRxRZ67m2LFYvqpWDUdd/Ebook_Florecer_021.png', 'https://cdn.magicpatterns.com/uploads/ijKDPcd3sgUM3oxWwAwbp6/Ebook_Florecer_031.png', 'https://cdn.magicpatterns.com/uploads/h5zb828ZW8sewx434jjxVT/Ebook_Florecer_036.png', 'https://cdn.magicpatterns.com/uploads/hUatg6twDpUPvKZwSckU8N/Ebook_Florecer_038.png'];
  const [activeIdx, setActiveIdx] = useState(0);
  const next = () => setActiveIdx(prev => (prev + 1) % images.length);
  const prev = () => setActiveIdx(prev => (prev - 1 + images.length) % images.length);
  return <section className="py-20 md:py-28 bg-sage-light/30 overflow-hidden" data-id="element-210">
      <div className="max-w-6xl mx-auto px-6" data-id="element-211">
        <div className="text-center mb-12 md:mb-16" data-id="element-212">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-213">
            👀 MIRÁ POR DENTRO
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-214">
            Páginas reales del material
          </h2>
          <p className="font-serif italic text-xl text-peach-dark" data-id="element-215">
            Esto es lo que vas a recibir
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-216">
          {/* Main viewport */}
          <div className="relative max-w-3xl mx-auto" data-id="element-217">
            <div className="relative aspect-[3/4] sm:aspect-[4/5] overflow-hidden rounded-3xl" data-id="element-218">
              {images.map((src, idx) => <motion.img key={idx} src={src} alt={`Página ${idx + 1} del ebook Florecer`} initial={false} animate={{
              opacity: idx === activeIdx ? 1 : 0,
              scale: idx === activeIdx ? 1 : 1.02
            }} transition={{
              duration: 0.5,
              ease: 'easeOut'
            }} className="absolute inset-0 w-full h-full object-contain bg-white rounded-3xl shadow-2xl shadow-peach/20 border border-peach-light/40" style={{
              pointerEvents: idx === activeIdx ? 'auto' : 'none'
            }} data-id="element-219" />)}
            </div>

            {/* Arrows */}
            <button onClick={prev} aria-label="Página anterior" className="absolute left-2 md:-left-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-peach hover:text-white transition-colors border border-peach-light z-10" data-id="element-220">
              <ChevronLeft className="w-6 h-6" data-id="element-221" />
            </button>
            <button onClick={next} aria-label="Página siguiente" className="absolute right-2 md:-right-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-peach hover:text-white transition-colors border border-peach-light z-10" data-id="element-222">
              <ChevronRight className="w-6 h-6" data-id="element-223" />
            </button>
          </div>

          {/* Dots indicator */}
          <div className="flex justify-center gap-2 mt-8" data-id="element-224">
            {images.map((_, idx) => <button key={idx} onClick={() => setActiveIdx(idx)} aria-label={`Ir a página ${idx + 1}`} className={`h-2 rounded-full transition-all ${idx === activeIdx ? 'bg-peach w-8' : 'bg-peach/30 w-2 hover:bg-peach/50'}`} data-id="element-225" />)}
          </div>

          {/* Thumbnails */}
          <div className="hidden md:grid grid-cols-5 lg:grid-cols-10 gap-3 mt-10 max-w-5xl mx-auto" data-id="element-226">
            {images.map((src, idx) => <button key={idx} onClick={() => setActiveIdx(idx)} aria-label={`Ver página ${idx + 1}`} className={`aspect-[3/4] overflow-hidden rounded-xl transition-all border-2 ${idx === activeIdx ? 'border-peach shadow-md scale-105' : 'border-transparent opacity-70 hover:opacity-100'}`} data-id="element-227">
                <img src={src} alt={`Miniatura página ${idx + 1}`} className="w-full h-full object-cover bg-white" data-id="element-228" />
              </button>)}
          </div>

          <p className="text-center text-sm text-text-muted mt-6" data-id="element-229">
            Deslizá para ver más páginas
          </p>
        </div>
      </div>
    </section>;
}